import React from "react";

type SpeakerIdentityProps = {
    name?: string;
    role?: string;
    avatar?: string;
};

export function SpeakerIdentity({ name, role, avatar }: SpeakerIdentityProps) {
    return (
        <div className="flex items-start gap-6 max-lg:gap-3">
            <div className="grid h-[100px] w-[100px] place-items-center overflow-hidden rounded-full bg-accent max-lg:h-[80px] max-lg:w-[80px] max-lg:rounded-[1205.96px]">
                <img
                    src={avatar}
                    alt=""
                    className="h-full w-full object-cover object-center"
                    loading="lazy"
                    decoding="async"
                />
            </div>
            <div className="w-[414px] max-lg:w-auto max-lg:flex-1">
                <h3 className="mb-2.5 w-[306px] text-[28px] leading-none font-bold tracking-[-0.04em] uppercase max-lg:mb-2 max-lg:w-full max-lg:text-[16px] max-lg:leading-[1]">
                    {name}
                </h3>
                {role ? (
                    <p className="m-0 text-base tracking-[-0.04em] text-muted max-lg:text-[16px] max-lg:leading-[1]">
                        {role}
                    </p>
                ) : null}
            </div>
        </div>
    );
}
